import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private configurationSubject: Subject<Configuration> = new BehaviorSubject(null);
  public configuration$: Observable<Configuration> = this.configurationSubject.asObservable().pipe(filter(val => val != null));

  private configuration: Configuration;
  private readonly configurationUrl ='/tracking/configuration';
  
  constructor(private http: HttpClient) {
    this.http.get<Configuration>(this.configurationUrl).subscribe(configuration => {
      this.configuration = configuration;
      this.configurationSubject.next(this.configuration);
    },
    err => {
      console.error('cannot get configuration', err);
      this.configurationSubject.error(err)
    })
  }
}


export interface Configuration {
  atInternetTagSite: string;
}
